/* swiperMain.autoplay.stop(); //画面に現れるまでswiperを停止
jQuery(window).on("scroll", function() {
  let position = jQuery(".swiperMain").offset().top - jQuery(window).innerHeight() + 100,
    scrollTop = jQuery(window).scrollTop();
  if (scrollTop > position) {
    swiperMain.autoplay.start(); //画面に現れたらswiperを開始
  } else {
    swiperMain.autoplay.stop(); // 画面外にスクロールしたらswiperを停止
  }
}); */

jQuery(window).on("load", function() {
  const swiper = new Swiper("#webslide .swiper", {
    centeredSlides: true, // 1枚目のスライドを中央にする
    loop: true, // ループさせる
    speed: 1000, // 少しゆっくり(デフォルトは300)
    slidesPerView: 1.5,
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
        slidesPerView: 3
      }
    },
    autoplay: {
      // 自動再生
      delay: 1000 // 3秒後に次のスライド
    },
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });

  const mv = new Swiper("#mv-slide-swiper.swiper", {
    centeredSlides: true, // 1枚目のスライドを中央にする
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    loop: false,
    speed: 1500, // 少しゆっくり(デフォルトは300)
    slidesPerView: 1, // スライドの表示枚数
    autoplay: {
      // 自動再生
      delay: 3000, // 3秒後に次のスライド
      disableOnInteraction: false // 矢印をクリックしても自動再生を止めない
    },
    // ページネーション
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
});
